import React, {Component, useDebugValue, useSyncExternalStore} from 'react';
import { useState } from "react";
import { FaEdit } from "react-icons/fa";
import { Button, Alert, Modal, Col, FormLabel } from 'react-bootstrap';
import CompetenciaDataService from './services/competencia.service.js';
import { Form, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { Controller, useForm } from "react-hook-form";
import {dtForInputDate} from './AuxiliaryFunctions.js'

function UpdateCompetencia(props) { 

  const { control, handleSubmit, formState: { errors },} = useForm({
    defaultValues: {
      /*
      primernombre: props.edituser.primernombre,      
      segundonombre: props.edituser.segundonombre,
      primerapellido: props.edituser.primerapellido,
      segundoapellido: props.edituser.segundoapellido,
      fechadenacimiento: dtForInputDate(props.edituser.fechadenacimiento),
      telefonomovil: props.edituser.telefonomovil,
      email: props.edituser.email,
      habilitado: props.edituser.habilitado,
      curp: props.edituser.curp,
      */
    },
  });  

  const [lgShow, setLgShow] = useState(false);
  const [Errmessage, setErrmessage] = useState("");
  const [Showerror, setShowerror] = useState("");
  const [Sucmessage, setSuccmessage] = useState("");
  const [Showsuccess, setShowsuccess] = useState("");
  const [Submitted, setSubmitted] = useState(false);
  const [mode, setMode] = useState(props.mode);


  const [nombrecompetencia, setnombrecompetencia] = useState("");
  const [descripcioncompetencia, setdescripcioncompetencia] = useState("");    
  const [fechainicio, setfechainicio] = useState("");    
  const [fechafin, setfechafin] = useState("");  
  const [estatus_competencia, setestatus_competencia] = useState(null);  
  
  const { user } = useSelector(state => state.auth);

  const onChangenombrecompetencia = (e) => {  
    //console.log(e.target.value);
    const nombrecompetencia = e.target.value;
    setnombrecompetencia(nombrecompetencia);
  };

  const onChangedescripcioncompetencia = (e) => {  
    //console.log(e.target.value);
    const descripcioncompetencia = e.target.value;
    setdescripcioncompetencia(descripcioncompetencia);
  };

  const onChangefechainicio = (e) => {  
    console.log(e.target.value);
    const fechainicio = e.target.value;
    setfechainicio(fechainicio);
  };

  const onChangefechafin = (e) => {  
    console.log(e.target.value);
    const fechafin = e.target.value;
    setfechafin(fechafin);
  };  

  const onChangeEstadoCompetencia = (e) => {
    console.log(e.target.value);
    const estatus_competencia = e.target.value;
    setestatus_competencia(parseInt(estatus_competencia));
  };
  
  const handleClose = () => {
    window.location.reload();
    setLgShow(false);
  }
  
  const handleShow = () => {
    CompetenciaDataService.get(props.id)
    .then(response => {
        console.log(response.data);
        setSuccmessage('');
        setErrmessage('');
        setShowerror(false);
        setShowsuccess(false);      
        setnombrecompetencia(response.data.nombrecompetencia);
        setdescripcioncompetencia(response.data.descripcioncompetencia);
        setfechainicio(response.data.fechainicio);
        setfechafin(response.data.fechafin);
        setestatus_competencia(response.data.estatus_competencia);
        setLgShow(true);        
      })      
    .catch(e => {
      console.log(e);
    });     
  }

  let handleValidations = () => {
    /*
    console.log(userRoles.length);
    if (username.length ==0 || userRoles.length == 0) {      
      setErrmessage('Campos requeridos.');
      setShowerror(true);
      return;
    }
    if (email) {
      if (!/\S+@\S+\.\S+/.test(email)) {
        setErrmessage('El correo no es válido.');
        setShowerror(true);      
        return;
      }
    }
    */
    saveCompetencia();
  } 

  let saveCompetencia = (e)  =>{ 
    console.log(e);
    console.log(nombrecompetencia);
    console.log(descripcioncompetencia);
    console.log(e.nombrecompetencia);
    console.log(e.descripcioncompetencia);   

    if (nombrecompetencia.length == 0) {
      setErrmessage("El nombre de la competencia no puede ser vacío.");
      setShowerror(true);
    }  
    else {
      var data = {
        nombrecompetencia: e.nombrecompetencia,
        descripcioncompetencia: e.descripcioncompetencia,
        fechainicio: e.fechainicio,
        fechafin: e.fechafin,
        estatus_competencia: e.estatus_competencia,
      }
      
      console.log(data);
      
      CompetenciaDataService.update(props.id, data)
      .then(response => {
        console.log(response);
        setSubmitted(true);
        setSuccmessage('Se actualizó la competencia.');
        setShowsuccess(true);
        setErrmessage('');
        setShowerror(false);        
        handleClose();
      })
      .catch(e => {
        console.log(e);
        setErrmessage(e.response?e.response.data.message:e.message);
        setShowerror(true);      
        setSuccmessage('');
        setShowsuccess(false);            
      })   
  
    }    
  }


    return (
      <>
        <Button variant="secondary" onClick={handleShow}><FaEdit size={15}/></Button>      
        <Modal
          size="lg"
          show={lgShow}
          onHide={() => {handleClose();setLgShow(false)}}
          aria-labelledby="example-modal-sizes-title-lg"
        >
          <Modal.Header closeButton>
            <Modal.Title id="example-modal-sizes-title-lg">
              {'Actualizar competencia'}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>

            <Form noValidate onSubmit={handleSubmit(saveCompetencia)}>
              <Row className='mt-2'>
                <Col className='col-md-3' sm={8}>
                    <Controller
                        name="nombrecompetencia"
                        control={control}
                        onChange={onChangenombrecompetencia}
                        defaultValue={nombrecompetencia}
                        rules={{ required: true }}
                        render={({ field }) => (
                            <Form.Control
                            {...field}
                                className="m-2"
                                type="text"
                                placeholder="Nombre competencia"
                                isInvalid={errors.nombrecompetencia}
                                
                            />
                        )}
                    />
                    {errors.nombrecompetencia && (
                        <Form.Control.Feedback type="invalid">
                            Se requiere el nombre de la competencia.
                        </Form.Control.Feedback>
                    )}
                </Col>

                <Col sm={4}>
                    <Controller
                        name="fechainicio"
                        control={control}
                        onChange={onChangefechainicio}
                        defaultValue={dtForInputDate(fechainicio)}
                        //value={dtForInputDate(fechainicio)}
                        rules={{ required: true }}
                        render={({ field }) => (
                        <Form.Control
                            {...field}
                            className="m-2"
                            type="date"
                            placeholder="Fecha inicio"
                            isInvalid={errors.fechainicio}
                            
                        />
                        )}
                    />
                    {errors.fechainicio && (
                        <Form.Control.Feedback type="invalid">
                            Se requiere la fecha de inicio de la competencia.
                        </Form.Control.Feedback>
                    )}        
                </Col>

                {/**
                <Col sm={4}>
                    <Controller
                        name="fechafin"
                        control={control}
                        onChange={onChangefechafin}
                        defaultValue={dtForInputDate(fechafin)}
                        //value={dtForInputDate(fechafin)}
                        rules={{ required: true }}
                        render={({ field }) => (
                        <Form.Control
                            {...field}
                            className="m-2"
                            type="date"
                            placeholder="Fecha fin"
                            isInvalid={errors.fechafin}
                            
                        />
                        )}
                    />
                    {errors.fechafin && (
                        <Form.Control.Feedback type="invalid">
                            Se requiere la fecha de fin de la competencia.
                        </Form.Control.Feedback>
                    )}        
                </Col>   
                */}             

                <Col className='col-sm-4' sm={4}>
                    <Controller
                        name="estatus_competencia"
                        control={control}
                        onChange={onChangeEstadoCompetencia}
                        defaultValue={estatus_competencia}
                        rules={{ required: false }}
                        render={({ field }) => (
                            <Form.Select
                            {...field}
                              className="m-2"
                              type="select"
                            >
                              <option key={0} value={0} disabled>{"Seleccionar estado de la competencia"}</option>
                              <option key={1} value={1}>Preliminar</option>
                              <option key={2} value={2}>Abierta</option>
                              <option key={3} value={3}>En curso</option>
                              <option key={4} value={4}>Cerrada</option>
                            </Form.Select>
                        )}
                    />
                </Col>     

                <Col className='col-md-6' md={12}>
                  <Controller
                    name="descripcioncompetencia"
                    control={control}
                    onChange={onChangedescripcioncompetencia}
                    defaultValue={descripcioncompetencia}
                    rules={{ required: true }}
                    render={({ field }) => (
                      <Form.Control
                        {...field}
                          className="m-2"
                          type="text"
                          placeholder="Descripción competencia"
                          isInvalid={errors.descripcioncompetencia}
                          
                      />
                    )}
                  />
                  {errors.descripcioncompetencia && (
                    <Form.Control.Feedback type="invalid">
                      Se requiere la descripción de la competencia.
                    </Form.Control.Feedback>
                  )}        
                </Col>
              </Row>
              <hr />
              <div className="d-flex justify-content-start flex-wrap">      
         
                <button className="btn btn-secondary btn-block">
                  Guardar y cerrar
                </button>            
              </div> 

            </Form>
              {Showerror && (
                <Alert variant="danger" onClose={() => setShowerror(false)} dismissible>
                  <Alert.Heading>Error</Alert.Heading>
                  <p>{Errmessage}</p>
                </Alert>      
              )}
              {Showsuccess && (
                <Alert variant="success" onClose={() => setShowsuccess(false)} dismissible>
                  <Alert.Heading>Hecho</Alert.Heading>
                  <p>{Sucmessage}</p>
                </Alert>      
              )}     
          </Modal.Body>
        </Modal>
      </>
    );
  }

  
  export default UpdateCompetencia;